import * as s from 'styled-components';
const styled = s.default;

export const Table: any = styled.table`
  width: 100%;
  margin: 0;
  padding: 0;
  border: ${({ theme }) => theme.formElements.table.border};
  border-radius: ${({ theme }) => theme.borderRadius};
  border-collapse: separate;
  border-spacing: 0 0;
`;

export interface TableColumn {
  align?: 'left' | 'center' | 'right';
}

export const TableTd: any = styled.td`
  text-align: ${(props: TableColumn) => props.align || 'left'};
`;

export const TableTh: any = styled.th`
  text-align: ${(props: TableColumn) => props.align || 'left'};
`;

export interface TableRowProps {
  clickable?: boolean;
}
export const TableRow: any = styled<TableRowProps, 'tr'>('tr')`
  cursor: ${props => (props.clickable ? 'pointer' : 'normal')};
  transition: all 0.1s ease-in-out;

  ${TableTh} {
    border-bottom: ${({ theme }) => theme.formElements.table.headerBorder};
    border-collapse: separate;
    border-spacing: 5px 5px;
    padding: 15px;
  }

  ${TableTd} {
    padding: 15px;
  }
`;

export const TableHead: any = styled.thead``;

export const TableBody: any = styled.tbody`
  ${TableRow}:hover {
    background: ${({ theme }) => theme.formElements.table.rowHoverColor};
  }
`;
